<div class="modal-header">
  <div *ngIf="
    selectedOption.toString() !== 'ADMIN_CREATE_FRANCHISE' && 
    selectedOption.toString() !== 'ADMIN_CREATE_FRANCHISED'
  ">
    <h4 class="modal-title" id="exampleModalLabel">
      {{ "addLP.title" | translate }}
    </h4>
    <h5>{{ "enumMapping.addLP." + selectedOption.toString() | translate }}</h5>
  </div>
  <div *ngIf="
    selectedOption.toString() === 'ADMIN_CREATE_FRANCHISE' || 
    selectedOption.toString() === 'ADMIN_CREATE_FRANCHISED'
  ">
    <h4 class="modal-title" id="exampleModalLabel">
      {{ "enumMapping.addLP." + selectedOption.toString() + ".title" | translate }}
    </h4>
    <h5>{{ "enumMapping.addLP." + selectedOption.toString() + ".description" | translate }}</h5>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onClickDismissAll()"
  ></button>
</div>
<div class="modal-body">
  <form
    novalidate
    class="theme-form login-form creation-form p-0"
    (ngSubmit)="submit()"
    [formGroup]="locationPartnerForm"
  >
    <aw-wizard #wizard [disableNavigationBar]="true">
      <aw-wizard-step formGroupName="personalInformation">
        <app-personal-information
          [form]="locationPartnerForm.get('personalInformation')! | asFormGroup"
          [isFranchised]="isFranchised"
        ></app-personal-information>

        <button
          class="btn btn-primary pull-right"
          type="button"
          (click)="verifyEmail()"
          [disabled]="!locationPartnerForm.get('personalInformation')?.valid"
        >
          {{ "buttons.next" | translate }}
        </button>
        <button
          class="btn btn-outline-primary pull-left me-1"
          type="button"
          (click)="clearForm()"
        >
          {{ "buttons.cancel" | translate }}
        </button>
      </aw-wizard-step>

      <aw-wizard-step formGroupName="companyInformation">
        <app-company-information
          [create]="true"
          [form]="locationPartnerForm.get('companyInformation')! | asFormGroup"
          [option]="update.optionSelected"
          [isFranchised]="isFranchised"
        ></app-company-information>
        <button
          class="btn btn-primary pull-right"
          [type]="isFranchise ? 'submit' : 'button'"
          (click)="isFranchise ? null : verifyCompanyName()"
          [disabled]="
            loading ||
            !locationPartnerForm.get('companyInformation')?.valid
          "
        >
          <ng-container *ngIf="isFranchise">
            <loading-button
              [loading]="loading"
              [value]="'buttons.confirm'"
              [icon]="null"
            ></loading-button>
          </ng-container>
          <ng-container *ngIf="!isFranchise">
            {{ "buttons.next" | translate }}
          </ng-container>
        </button>
        <button
          class="btn btn-outline-primary pull-left me-1"
          type="button"
          awPreviousStep
        >
          {{ "buttons.return" | translate }}
        </button>
      </aw-wizard-step>
      <aw-wizard-step  *ngIf="!isFranchise" formGroupName="locationInformation">
        <app-location-information
          [isUpdate]="false"
          [form]="locationPartnerForm.get('locationInformation')! | asFormGroup"
        ></app-location-information>
        <app-location-status *ngIf="isAdminLoggedIn"
          [form]="locationPartnerForm.get('locationInformation')! | asFormGroup"
        ></app-location-status>
        <button
          class="btn btn-primary pull-right"
          type="button"
          [disabled]="!locationPartnerForm.get('locationInformation')?.valid"
          awNextStep
        >
          {{ "buttons.next" | translate }}
        </button>
        <button
          class="btn btn-outline-primary pull-left me-1"
          type="button"
          awPreviousStep
        >
          {{ "buttons.return" | translate }}
        </button>
      </aw-wizard-step>
      <aw-wizard-step  *ngIf="!isFranchise && isAdminLoggedIn" formGroupName="routerInformation">
        <app-router-information
          [form]="locationPartnerForm.get('routerInformation')! | asFormGroup"
        ></app-router-information>
        <button
          class="btn btn-primary pull-right"
          type="submit"
          [disabled]="loading || !locationPartnerForm.get('routerInformation')?.valid"
          awNextStep
        >
          <loading-button
            [loading]="loading"
            [value]="'buttons.confirm'"
            [icon]="null"
          ></loading-button>
        </button>
        <button
          class="btn btn-outline-primary pull-left me-1"
          type="button"
          awPreviousStep
        >
          {{ "buttons.return" | translate }}
        </button>
      </aw-wizard-step>
      <aw-wizard-step  *ngIf="!isAdminLoggedIn">
        <form [formGroup]="locationPartnerForm.get('remuneration')! | asFormGroup">
          <div class="form-group">
            <label class="label"
              >{{ "availableFeatures.remuneration" | translate }} *</label
            >
            <div class="input-group">
              <select class="form-select form-control" formControlName="isActive">
                <option [ngValue]="null" disabled selected>
                  {{ "remunerationForFranchised.chooseRemuneration" | translate }}
                </option>
                <option [ngValue]="true">
                  {{  "remunerationForFranchised.activated" | translate }}
                </option>
                <option [ngValue]="false">
                  {{  "remunerationForFranchised.deactivated" | translate }}
                </option>
              </select>
            </div>
          </div>
        </form>
        <button
          class="btn btn-primary pull-right"
          type="submit"
          [disabled]="loading || !locationPartnerForm.get('remuneration')?.valid"
          awNextStep
        >
          <loading-button
            [loading]="loading"
            [value]="'buttons.confirm'"
            [icon]="null"
          ></loading-button>
        </button>
        <button
          class="btn btn-outline-primary pull-left me-1"
          type="button"
          awPreviousStep
        >
          {{ "buttons.return" | translate }}
        </button>
      </aw-wizard-step>
    </aw-wizard>
  </form>
</div>
